import axios from "axios";

const development = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

export default function isDev() {
    return development;
}

let backend = 'https://api.yeticlean.co.uk/'

if (isDev()) {
    backend = 'http://127.0.0.1:8000/'
}


export const Axios = axios.create({
    baseURL: backend,
    headers: {
        "Content-Type": "application/json",
    },
});

export function AddLead(name, phone, email, franchise_type, territory_location, facebook_data) {
    return new Promise((resolve, reject) => {
        return Axios({
            url: backend + 'franchisees/add-lead/',
            method: "POST",
            data: {
                name,
                phone,
                email,
                franchise_type,
                territory_location,
                facebook_data: facebook_data
            },
            headers: {
                "Content-Type": "application/json",
            }
        }).then((data) => {
            resolve(data.data);
        }).catch(error => {
            reject(error);
        });
    });
}
